<template>
    <a v-if="row.IsPaymentSuccessfull" :href="'/Receipt/'+row.SystemReceiptCode" target="_blank">{{row.SystemReceiptCode}}</a>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{

    }
}
</script>